exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal{background:hsl(0deg 0% 7% / 50%)}\n#alertModal .modal-dialog{max-width: 320px;}\n.modal-title{font-size: 1rem;}\n.modal-body .msg{font-size: 1rem;text-transform: capitalize;}\n\n", ""]);

// exports
